/** My Workspace: org power user viewing another member's workspace. */

export const WORKSPACE_USER_ID_PARAM = "workspace_user_id";

export function getEffectiveWorkspaceUserId(selectedId, currentUserId) {
  if (!selectedId || selectedId === currentUserId) {
    return currentUserId ?? selectedId ?? null;
  }
  return selectedId;
}

export function buildWorkspaceGroupsUrl(
  workspaceUserId,
  currentUserId,
  { skipPrefetch = false } = {},
) {
  const effectiveId = getEffectiveWorkspaceUserId(workspaceUserId, currentUserId);
  const params = new URLSearchParams();
  if (effectiveId && effectiveId !== currentUserId) {
    params.set("workspace_user_id", effectiveId);
  }
  if (skipPrefetch) {
    params.set("skip_prefetch", "1");
  }
  const qs = params.toString();
  return qs ? `welcome/groups/all?${qs}` : "welcome/groups/all";
}

export function buildWorkspaceArchivedGroupsUrl(workspaceUserId, currentUserId) {
  const effectiveId = getEffectiveWorkspaceUserId(workspaceUserId, currentUserId);
  if (!effectiveId || effectiveId === currentUserId) {
    return "welcome/groups/archived";
  }
  const params = new URLSearchParams();
  params.set("workspace_user_id", effectiveId);
  return `welcome/groups/archived?${params.toString()}`;
}

export function appendWorkspaceUserId(payload, workspaceUserId, currentUserId) {
  const effectiveId = getEffectiveWorkspaceUserId(workspaceUserId, currentUserId);
  if (!effectiveId || effectiveId === currentUserId) {
    return payload;
  }
  return { ...payload, workspace_user_id: effectiveId };
}

export function readWorkspaceUserIdFromSearch(search) {
  const raw = new URLSearchParams(search || "").get(WORKSPACE_USER_ID_PARAM);
  const trimmed = raw?.trim();
  return trimmed || null;
}

export function applyWorkspaceUserIdToSearchParams(
  params,
  workspaceUserId,
  currentUserId,
) {
  const effectiveId = getEffectiveWorkspaceUserId(workspaceUserId, currentUserId);
  if (!effectiveId || effectiveId === currentUserId) {
    params.delete(WORKSPACE_USER_ID_PARAM);
  } else {
    params.set(WORKSPACE_USER_ID_PARAM, effectiveId);
  }
  return params;
}
